import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocationAutocompleteWithQuery } from "@/utils/hooks";
import { BusinessDetailsFormProps, BusinessDetails } from "@/features/partner-with-us/BusinessDetailsForm/types";
import { FormField, LocationInput, SubmitSection } from "@/features/partner-with-us/BusinessDetailsForm/components";
import { FORM_VALIDATION, FORM_FIELDS } from "@/features/partner-with-us/BusinessDetailsForm/constants";
import styles from "./main.module.css";
const BusinessDetailsForm: React.FC<BusinessDetailsFormProps> = t0 => {
  const $ = _c(76);
  const {
    onSubmit,
    initialData: t1,
    isLoading: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const initialData = t3;
  const isLoading = t2 === undefined ? false : t2;
  const [locationError, setLocationError] = useState(null);
  let t4;
  if ($[2] !== initialData) {
    t4 = {
      defaultValues: initialData
    };
    $[2] = initialData;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    register,
    handleSubmit,
    formState: t5,
    setValue,
    setError,
    clearErrors
  } = useForm(t4);
  const {
    errors
  } = t5;
  const {
    inputValue,
    suggestions,
    handleInputChange: originalHandleInputChange,
    handleInputFocus,
    handleInputBlur,
    handleSelectSuggestion,
    handleFormSubmitAttempt,
    checkLocationValidForSubmit,
    setInputValue,
    isLoadingSuggestions,
    suggestionsError,
    validateLocation,
    getLocationErrorMessage,
    isLocationSelected,
    hasShownSuggestions,
    isFocused
  } = useLocationAutocompleteWithQuery(initialData.location);
  let t6;
  if ($[4] !== clearErrors || $[5] !== locationError || $[6] !== originalHandleInputChange) {
    t6 = e => {
      if (locationError) {
        setLocationError(null);
        clearErrors("location");
      }
      originalHandleInputChange(e);
    };
    $[4] = clearErrors;
    $[5] = locationError;
    $[6] = originalHandleInputChange;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const handleInputChange = t6;
  let t7;
  let t8;
  if ($[8] !== initialData || $[9] !== setInputValue || $[10] !== setValue) {
    t7 = () => {
      if (initialData) {
        Object.entries(initialData).forEach(t9 => {
          const [key, value] = t9;
          setValue(key as keyof BusinessDetails, value);
        });
        if (initialData.location) {
          setInputValue(initialData.location);
        }
      }
    };
    t8 = [initialData, setValue, setInputValue];
    $[8] = initialData;
    $[9] = setInputValue;
    $[10] = setValue;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[13] !== clearErrors || $[14] !== isLocationSelected || $[15] !== locationError) {
    t9 = () => {
      if (locationError && isLocationSelected) {
        setLocationError(null);
        clearErrors("location");
      }
    };
    t10 = [isLocationSelected, locationError, clearErrors];
    $[13] = clearErrors;
    $[14] = isLocationSelected;
    $[15] = locationError;
    $[16] = t10;
    $[17] = t9;
  } else {
    t10 = $[16];
    t9 = $[17];
  }
  useEffect(t9, t10);
  let t11;
  if ($[18] !== checkLocationValidForSubmit || $[19] !== clearErrors || $[20] !== getLocationErrorMessage || $[21] !== handleFormSubmitAttempt || $[22] !== onSubmit || $[23] !== setError) {
    t11 = data => {
      handleFormSubmitAttempt();
      const isValid = checkLocationValidForSubmit();
      if (!isValid) {
        const errorMessage = getLocationErrorMessage();
        if (errorMessage) {
          setLocationError(errorMessage);
          setError("location", {
            type: "manual",
            message: errorMessage
          });
        }
        return;
      }
      setLocationError(null);
      clearErrors("location");
      onSubmit(data);
    };
    $[18] = checkLocationValidForSubmit;
    $[19] = clearErrors;
    $[20] = getLocationErrorMessage;
    $[21] = handleFormSubmitAttempt;
    $[22] = onSubmit;
    $[23] = setError;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  const handleFormSubmit = t11;
  let t12;
  if ($[25] !== handleFormSubmit || $[26] !== handleSubmit) {
    t12 = handleSubmit(handleFormSubmit);
    $[25] = handleFormSubmit;
    $[26] = handleSubmit;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== errors.businessName || $[29] !== isLoading || $[30] !== register) {
    t13 = <FormField label={FORM_FIELDS.businessName.label} name="businessName" placeholder={FORM_FIELDS.businessName.placeholder} register={register} validation={FORM_VALIDATION.businessName} error={errors.businessName} disabled={isLoading} />;
    $[28] = errors.businessName;
    $[29] = isLoading;
    $[30] = register;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== errors.location || $[33] !== locationError) {
    t14 = locationError ? {
      type: "manual",
      message: locationError
    } : errors.location;
    $[32] = errors.location;
    $[33] = locationError;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== handleInputBlur || $[36] !== handleInputChange || $[37] !== handleInputFocus || $[38] !== handleSelectSuggestion || $[39] !== hasShownSuggestions || $[40] !== inputValue || $[41] !== isFocused || $[42] !== isLoading || $[43] !== isLoadingSuggestions || $[44] !== isLocationSelected || $[45] !== register || $[46] !== setValue || $[47] !== suggestions || $[48] !== suggestionsError || $[49] !== t14 || $[50] !== validateLocation) {
    t15 = <LocationInput inputValue={inputValue} suggestions={suggestions} register={register} setValue={setValue} handleInputChange={handleInputChange} handleInputFocus={handleInputFocus} handleInputBlur={handleInputBlur} handleSelectSuggestion={handleSelectSuggestion} error={t14} isLoading={isLoading} isLoadingSuggestions={isLoadingSuggestions} suggestionsError={suggestionsError} validateLocation={validateLocation} isLocationSelected={isLocationSelected} hasShownSuggestions={hasShownSuggestions} isFocused={isFocused} />;
    $[35] = handleInputBlur;
    $[36] = handleInputChange;
    $[37] = handleInputFocus;
    $[38] = handleSelectSuggestion;
    $[39] = hasShownSuggestions;
    $[40] = inputValue;
    $[41] = isFocused;
    $[42] = isLoading;
    $[43] = isLoadingSuggestions;
    $[44] = isLocationSelected;
    $[45] = register;
    $[46] = setValue;
    $[47] = suggestions;
    $[48] = suggestionsError;
    $[49] = t14;
    $[50] = validateLocation;
    $[51] = t15;
  } else {
    t15 = $[51];
  }
  let t16;
  if ($[52] !== errors.pincode || $[53] !== isLoading || $[54] !== register) {
    t16 = <div className={styles.column}><FormField label={FORM_FIELDS.pincode.label} name="pincode" placeholder={FORM_FIELDS.pincode.placeholder} register={register} validation={FORM_VALIDATION.pincode} error={errors.pincode} disabled={isLoading} /></div>;
    $[52] = errors.pincode;
    $[53] = isLoading;
    $[54] = register;
    $[55] = t16;
  } else {
    t16 = $[55];
  }
  let t17;
  if ($[56] !== errors.fssaiNumber || $[57] !== isLoading || $[58] !== register) {
    t17 = <div className={styles.column}><FormField label={FORM_FIELDS.fssaiNumber.label} name="fssaiNumber" placeholder={FORM_FIELDS.fssaiNumber.placeholder} register={register} validation={FORM_VALIDATION.fssaiNumber} error={errors.fssaiNumber} disabled={isLoading} /></div>;
    $[56] = errors.fssaiNumber;
    $[57] = isLoading;
    $[58] = register;
    $[59] = t17;
  } else {
    t17 = $[59];
  }
  let t18;
  if ($[60] !== t16 || $[61] !== t17) {
    t18 = <div className={styles.twoColumnLayout}>{t16}{t17}</div>;
    $[60] = t16;
    $[61] = t17;
    $[62] = t18;
  } else {
    t18 = $[62];
  }
  let t19;
  if ($[63] !== errors.gstNumber || $[64] !== isLoading || $[65] !== register) {
    t19 = <FormField label={FORM_FIELDS.gstNumber.label} name="gstNumber" placeholder={FORM_FIELDS.gstNumber.placeholder} register={register} validation={FORM_VALIDATION.gstNumber} error={errors.gstNumber} disabled={isLoading} />;
    $[63] = errors.gstNumber;
    $[64] = isLoading;
    $[65] = register;
    $[66] = t19;
  } else {
    t19 = $[66];
  }
  let t20;
  if ($[67] !== isLoading) {
    t20 = <SubmitSection isLoading={isLoading} />;
    $[67] = isLoading;
    $[68] = t20;
  } else {
    t20 = $[68];
  }
  let t21;
  if ($[69] !== t12 || $[70] !== t13 || $[71] !== t15 || $[72] !== t18 || $[73] !== t19 || $[74] !== t20) {
    t21 = <form onSubmit={t12} className={styles.form}>{t13}{t15}{t18}{t19}{t20}</form>;
    $[69] = t12;
    $[70] = t13;
    $[71] = t15;
    $[72] = t18;
    $[73] = t19;
    $[74] = t20;
    $[75] = t21;
  } else {
    t21 = $[75];
  }
  return t21;
};
export default BusinessDetailsForm;